import { Button, Hotspot, Icon } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../../common/Localization';
import { HotspotIds } from '../../../tutorials/HotspotIds';

interface Props {
    onFileUpload: (file: any) => void;
    acceptTypes?: string[];
}

class FileUpload extends React.Component<Props> {
    fileToUploadElement: HTMLInputElement | null;

    constructor(props: Props) {
        super(props);
    }

    render() {
        const acceptTypes = this.props.acceptTypes?.join(', ');
        return (
            <div>
                <div>
                    <input
                        className={'file-upload-input'}
                        type='file'
                        ref={ref => this.fileToUploadElement = ref}
                        onChange={this.selectFileHandler}
                        accept={acceptTypes}
                    />
                    <Hotspot hotspotId={HotspotIds.FILE_UPLOAD_BUTTON} />
                    <span>
                        <Button onClick={this.onFileUploadClick}>
                            <Icon name={'upload'} /> <span>{constants.UPLOAD_LOCAL_FILE_BUTTON}</span>
                        </Button>
                    </span>
                </div>
            </div>
        );
    }

    onFileUploadClick = (): void => {
        this.fileToUploadElement?.click();
    };

    selectFileHandler = (e: any): void => {
        e.preventDefault();
        const file = e.target.files[0];
        if (file) {
            this.props.onFileUpload(file);
        }
    };
}

export default FileUpload;
